// extracted by mini-css-extract-plugin
export default {"main":"styles_main__lnhdD","img_side":"styles_img_side__zQbY3","form_side":"styles_form_side__FSRVy"};